import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  MuiPaperRoot: {
    background: '#23232F',
    color: theme.colors.white,
    borderRadius: '0 !important',
    boxShadow: 'none',
  },
  MuiSvgIconRoot: {
    fill: theme.colors.white,
  },
  MuiAccordionSummaryContent: {
    display: 'initial',
  },

  MuiExpanded: {
    margin: '12px 0',
  },

  caseTitle: {
    paddingBottom: '4px',
    fontSize: '14px',
    fontFamily: 'EYInterstate-Light',
    maxWidth: '170px !important',
    wordBreak: 'break-all !important',
  },
  MuiAccordionDetailsRoot: {
    padding: '0',
  },
  MuiAccordionSummaryRoot: {
    minHeight: '45px !important',
  },
});

const AccordionPanel = ({ id, isOpen, dataTitle1, dataTitle2, children, classes, dataTitle1ToolTip }) => {
  return (
    <div>
      <Accordion defaultExpanded={isOpen} classes={{ root: classes.MuiPaperRoot }}>
        <AccordionSummary
          classes={{ root: classes.MuiAccordionSummaryRoot, content: classes.MuiAccordionSummaryContent }}
          expandIcon={<ExpandMoreIcon classes={{ root: classes.MuiSvgIconRoot }} />}
          aria-controls="panel1a-content"
          id={id}>
          <div title={dataTitle1ToolTip || ''} className={classes.caseTitle}>
            {dataTitle1}
          </div>
          <div className="font-10 font-light">{dataTitle2}</div>
        </AccordionSummary>
        <AccordionDetails classes={{ root: classes.MuiAccordionDetailsRoot }}>
          <div className="w-100">{children}</div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

AccordionPanel.propTypes = {
  dataTitle1: PropTypes.string.isRequired,
  dataTitle2: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

export default styled(AccordionPanel)(styles);
